import React, { Component } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';

import ParticipantAvatar from './avatar/participant_avatar';
import OPPureComponent from './op_pure_component';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { EMPLOYER_TYPE_AIRFORCE } from '../../constants/employerTypes';

import {
  getCurrentCaseParticipantsExcludingCurrentUser,
  getEditingCaseParticipantsExcludingCurrentUser,
  getCurrentCaseEmployerType,
} from '../cases/selector';

class Members extends OPPureComponent {
  constructor(props) {
    super(props);
  }

  horizontalParticipantView = (item) => {
    return (
      <View style={styles.horizontalProfileViewContainer} key={item.participant.userId}>
        <ParticipantAvatar
          participant={item}
          circleStyles={styles.avatar}
          onPress={null}
          showNameLabel={true}
          isAirforce={this.props.isAirforce}
        />
      </View>
    );
  };

  wrapParticipantView = (item) => {
    return (
      <ParticipantAvatar
        key={item.participant.userId}
        participant={item}
        circleStyles={styles.avatar}
        onPress={null}
        showNameLabel={true}
        isAirforce={this.props.isAirforce}
      />
    );
  };

  filteredParticipants() {
    const participants = this.props.participants;
    const memberIds = this.props.memberIds;

    let filtered;
    if (memberIds) {
      const idsHash = memberIds.reduce((result, current) => {
        result[current] = true;
        return result;
      }, {});

      filtered = participants.filter((p) => !!idsHash[p.participant.userId]);
    }
    if (!filtered) filtered = participants;

    return filtered;
  }

  render() {
    const participants = this.filteredParticipants();

    // const participants = [].concat(this.props.participants).concat(this.props.participants).concat(this.props.participants).concat(this.props.participants);

    if (this.props.horizontal) {
      return (
        <ScrollView
          contentContainerStyle={styles.horizontalScrollViewContent}
          showsHorizontalScrollIndicator={false}
          showsVerticalScrollIndicator={false}
          horizontal={true}
        >
          {participants.map(this.horizontalParticipantView)}
        </ScrollView>
      );
    } else {
      return (
        <View style={[styles.wrapContainer, this.props.containerStyle]}>
          {participants.map(this.wrapParticipantView)}
        </View>
      );
    }
  }
}

const styles = StyleSheet.create({
  wrapContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: 15,
  },
  avatar: {
    width: 50,
    height: 50,
  },
  horizontalScrollViewContent: {
    padding: 10,
    paddingBottom: 0,
  },
  horizontalProfileViewContainer: {
    marginHorizontal: 10,
  },
});

function mapStateToProps(state, ownProps) {
  // use the memoized getCurrentCaseParticipants when the instance is used
  // for the current case. Members instance for editingCase is used in
  // invites screen when opened via case info screen
  const participants = ownProps.editingCase
    ? getEditingCaseParticipantsExcludingCurrentUser(state)
    : getCurrentCaseParticipantsExcludingCurrentUser(state);
  return {
    participants,
    userProfile: state.entities.userProfile,
    isAirforce: getCurrentCaseEmployerType(state) === EMPLOYER_TYPE_AIRFORCE,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Members);
